export default __webpack_public_path__ + "static/media/furgon-pequeno.ca714327.webp";